import {
  ON_HIDE_LOADER,
  ON_SHOW_LOADER,
  TOGGLE_APP_ERROR,
  TOGGLE_COLLAPSED_NAV,
  WINDOW_WIDTH,
  SAVE_SETTING,
  CHANGE_SEARCH,
  SHOW_APPLAUSE,
  HIDE_APPLAUSE,
  CHANGE_SETTING,
  LOG_APP_ERROR,
} from 'constants/ActionTypes';
import { NAV_STYLE } from 'constants/ThemeSetting';

// Handles collapsing of the sidebar from topbar, when width is lesser then TAB_SIZE = 992
export const toggleCollapsedSideNav = (navCollapsed) => {
  return { type: TOGGLE_COLLAPSED_NAV, navCollapsed };
};

// Handles resizing on width change
export const updateWindowWidth = (width) => {
  return { type: WINDOW_WIDTH, width };
};

// Handles collapsing of the sidebar
export const onNavStyleChange = (navStyle) => {
  return { type: NAV_STYLE, navStyle };
};

export const showLoader = () => {
  return {
    type: ON_SHOW_LOADER,
  };
};

export const hideLoader = () => {
  return {
    type: ON_HIDE_LOADER,
  };
};

// Handles displaying of the application errors
export const toggleAppError = (errorCode, errorContent) => {
  return {
    type: TOGGLE_APP_ERROR,
    errorCode,
    errorContent,
  };
};
// Handles sending of the application error to the backend to log them
export const logAppError = (values) => {
  return {
    type: LOG_APP_ERROR,
    values,
  };
};

// Handler for save setting in backend
export const saveSetting = (key, value, loadHandler = null, payload = {}) => {
  return {
    type: SAVE_SETTING,
    payload: {
      resource: 'state',
      method: 'PUT',
      onSuccess: loadHandler,
      ...payload,
    },
    values: { key, value },
  };
};

// Handler for change settings in frontend
export const changeSetting = (path, value) => {
  return {
    type: CHANGE_SETTING,
    path,
    value,
  };
};

// Action for change search
export const changeSearch = (search) => {
  return {
    type: CHANGE_SEARCH,
    search,
  };
};

// Action for show applause
export const showApplause = () => {
  return {
    type: SHOW_APPLAUSE,
  };
};

// Action for hide applause
export const hideApplause = () => {
  return {
    type: HIDE_APPLAUSE,
  };
};
